var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7536 14L25.7831 2.98723C26.0734 2.65718 26.234 2.21512 26.2304 1.75628C26.2268 1.29743 26.0592 0.858511 25.7637 0.534047C25.4682 0.209583 25.0684 0.0255378 24.6506 0.0215505C24.2327 0.0175633 23.8301 0.193953 23.5295 0.51273L13.5001 11.5255L3.47058 0.51273C3.17 0.193953 2.76742 0.0175633 2.34954 0.0215505C1.93166 0.0255378 1.53193 0.209583 1.23644 0.534047C0.940942 0.858511 0.773329 1.29743 0.769698 1.75628C0.766067 2.21512 0.926708 2.65718 1.21702 2.98723L11.2465 14L1.21702 25.0127C1.0648 25.1742 0.943386 25.3673 0.85986 25.5808C0.776333 25.7943 0.732368 26.0239 0.730529 26.2563C0.72869 26.4886 0.769015 26.7191 0.84915 26.9341C0.929285 27.1492 1.04763 27.3446 1.19727 27.5089C1.34691 27.6732 1.52485 27.8032 1.72072 27.8912C1.91659 27.9792 2.12645 28.0234 2.33807 28.0214C2.54968 28.0194 2.75882 27.9711 2.95326 27.8794C3.1477 27.7877 3.32357 27.6544 3.47058 27.4872L13.5001 16.4745L23.5295 27.4872C23.8301 27.806 24.2327 27.9824 24.6506 27.9784C25.0684 27.9744 25.4682 27.7904 25.7637 27.4659C26.0592 27.1414 26.2268 26.7025 26.2304 26.2437C26.234 25.7848 26.0734 25.3428 25.7831 25.0127L15.7536 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/CloseButton.13e4d7a5.svg";
export { ForwardRef as ReactComponent };